import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field, formValueSelector } from "redux-form";
import { FormGroup, Label, Collapse, Modal, ModalBody } from "reactstrap";
import Aux from "../../../system/containers/Aux";

import Wysiwyg from "../../../system/fields/Wysiwyg";
import FileUpload from "../../../system/fields/FileUpload";
import AddressSearch from '../../../system/fields/AddressSearch';
import SelectDropdown from '../../../system/fields/SelectDropdown';
import * as validations from "../../../system/utils/Validation";

import DealNewHotelWrapper  from './DealNewHotelWrapper';
import DealNewCityWrapper from './DealNewCityWrapper';
import TextInput from "../../../system/fields/TextInput";
import CreatableSelect from "../../../system/fields/CreatableSelect";

class DestinationLegs extends Component {
  constructor(props, leg, index, fields) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.toggleHotel = this.toggleHotel.bind(this);
    this.toggleCity = this.toggleCity.bind(this);
    this.state = {
      collapse: true,
      hotelToggle: false,
      cityToggle: false,
     };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  toggleCity() {
    this.setState({
      cityToggle: !this.state.cityToggle,
    })
  }

  toggleHotel() {
    this.setState({
      hotelToggle: !this.state.hotelToggle,
    })
  }

  render() {
    return (
      <Aux>
        {!this.state.collapse && (
          <div className="toggle" onClick={this.toggle}>
            <i className="fas fa-eye" /> <span>Expand</span>
          </div>
        )}
        {this.state.collapse && (
          <div className="toggle" onClick={this.toggle}>
            <i className="fas fa-eye-slash" /> <span>Collapse</span>
          </div>
        )}

        <div className="top-field">
          <Label>Destination</Label>
          <Field
            name={`${this.props.leg}.leg_detail.destination`}
            placeholder="Enter Destination"
            component={SelectDropdown}
            options={this.props.cities}
            labelKey={"label"}
            valueKey={"id"}
            type="text"
            validate={validations.required}
          />
          <a href="#" role="button" onClick={this.toggleCity}>Add City</a>
          <Modal isOpen={this.state.cityToggle} toggle={this.toggleCity}>
            <ModalBody>
              <DealNewCityWrapper />
            </ModalBody>
          </Modal>
        </div>

        <Collapse isOpen={this.state.collapse}>
          <div className="row">
            <FormGroup className="col-12 col-md-6">
              <Label>Destination Tags</Label>
              <Field
                name={`${this.props.leg}.leg_detail.tags`}
                component={CreatableSelect}
                labelKey={"value"}
                valueKey={"id"}
                options={this.props.tags}
                multi
              />
            </FormGroup>
            <FormGroup className="col-12 col-md-6">
              <Label>Day From - To</Label>
              <Field
                name={`${this.props.leg}.leg_detail.day_from_to`}
                component={TextInput}
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className="col-12">
              <Label htmlFor="email">Summary</Label>
              <Field
                name={`${this.props.leg}.leg_detail.summary`}
                component={Wysiwyg}
                placeholder="Sub Title"
                type="text"
                size="sm"
                validate={validations.required}
              />
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Images</Label>
              <Field
                name={`${this.props.leg}.leg_detail.images`}
                component={FileUpload}
                multiple={true}
                files={false}
                images={true}
                type="text"
                className="form-control"
                validate={[validations.required, validations.fiveImages]}
              />
            </FormGroup>

            <FormGroup className="col-12 col-sm-6">
              <Label>Hotel Select</Label>
              <Field
                name={`${this.props.leg}.leg_detail.hotel`}
                component={SelectDropdown}
                options={this.props.hotels}
                labelKey={"name"}
                valueKey={"id"}
                type="text"
                multi={false}
                className="form-control"
              />
              <a href="#" role="button" onClick={this.toggleHotel}>Add Hotel</a>
              <Modal isOpen={this.state.hotelToggle} toggle={this.toggleHotel}>
                <ModalBody>
                  <DealNewHotelWrapper />
                </ModalBody>
              </Modal>
            </FormGroup>
            {this.props.hasHotel !== null && this.props.hasHotel !== undefined && this.props.hasHotel !== '' &&
            <FormGroup className={"col-12 col-sm-6"}>
              <Label>Board Type</Label>
              <Field
                name={`${this.props.leg}.leg_detail.hotel_room_type`}
                component={SelectDropdown}
                options={this.props.hasHotel.board_types}
                labelKey={"name"}
                valueKey={"id"}
                type={"text"}
                multi={false}
                className={"form-control"}
                validate={validations.required}
              />
            </FormGroup>
            }
          </div>
        </Collapse>
      </Aux>
    );
  }
}

const selector = formValueSelector('DealForm');

const mapStateToProps = (state, ownProps) => {
  return {
    hotels: state.overview.hotels,
    cities: state.overview.cities,
    tags: state.overview.tags,
    hasHotel: selector(state, `${ownProps.leg}.leg_detail.hotel`),
  }
};

export default connect(mapStateToProps)(DestinationLegs);



// WEBPACK FOOTER //
// ./src/containers/Deals/components/DestinationLegs.jsx